<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.status" placeholder="请选择" size="small">
				        <el-option label="不限制中签状态" value=""></el-option>
				        <el-option label="中签" :value="1"></el-option>
				        <el-option label="未中签" :value="0"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-input v-model="params.searchValue" class="input-with-select" size="small">
				        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
				            <el-option label="用户ID" :value="1"></el-option>
							<el-option label="用户昵称" :value="2"></el-option>
				            <el-option label="姓名" :value="3"></el-option>
							<el-option label="手机号" :value="4"></el-option>
							<el-option label="身份证号" :value="5"></el-option>
				        </el-select>
				    </el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
				    <div class="clearfix timeType">
				        <el-input class="input-with-select fl" size="small">
				            <el-select v-model="dateType" slot="prepend" placeholder="请选择">
				                <el-option label="申购时间" :value="1"></el-option>				                
				            </el-select>
				        </el-input>
				        <el-date-picker
				            v-model="date"
				            type="datetimerange"
				            start-placeholder="开始时间"
				            end-placeholder="结束时间"
				            class="fl"
				            size="small"
				            :default-time="['00:00:00', '23:59:59']"
				            value-format="yyyy-MM-dd HH:mm:ss"
				            unlink-panels
				            >
				        </el-date-picker>
				    </div>
				</el-col>				
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/shop_good/createOrUpdate')" type="primary" size="small" @click="setStatus('',1,1)">批量设为中签</el-button>
            <el-button v-if="$utils.have('/shop_good/createOrUpdate')" type="primary" size="small" @click="setStatus('',0,1)">批量取消中签</el-button>
            <el-button v-if="$utils.have('/shop_good/createOrUpdate')" type="primary" size="small" @click="download()" :loading="downLoading">导出名单</el-button>
            <el-button v-if="$utils.have('/shop_good/createOrUpdate')" type="primary" size="small" @click="$refs.importSubscribe.show()">导入中签白名单</el-button>
        </div>
		<div>当前项目公示中签时间为 ：<span class="color-danger">{{publicityTime}}</span> 建议在此节点前确定中签名单。节点后调整中签名单用户申购结果会有出入</div>
        <div class="page-list-box">			
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
				@selection-change="handleSelectionChange"
            >	<el-table-column type="selection"></el-table-column>
                <el-table-column label="中签状态" prop="subscriptionStatus">
                	 <template slot-scope="scope">
                	     <span v-if="scope.row.status == 0">未中签</span>
                	     <span v-else-if="scope.row.status == 1">中签</span>
                	 </template>   
                </el-table-column>
				<el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="nickName" label="用户昵称" min-width="200" ></el-table-column>
				<el-table-column prop="userName" label="姓名" ></el-table-column>
				<el-table-column prop="telephone" label="账号手机号" ></el-table-column>
				<el-table-column prop="idCardNum" label="身份证号" ></el-table-column>				
				<el-table-column label="申购时间" prop="time" :min-width="180"></el-table-column>
				
                <el-table-column fixed="right" label="操作" width="180">
                    <template v-if="$utils.have('/subscribe/user/setStatus')"  slot-scope="scope">
                        <el-button
                            v-if="scope.row.status == 1"
                            type="text"
                            size="small"
                            icon="el-icon-remove-outline"
                            @click="setStatus(scope.row.userId,0,2)"
                            >取消中签</el-button
                        >
                        <el-button
                            v-else
                            type="text"
                            size="small"
                            icon="el-icon-circle-check"
                            @click="setStatus(scope.row.userId,1,2)"
                            >设为中签</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <ImportSubscribe ref="importSubscribe" :id="id"  @update="getDataList()" ></ImportSubscribe>
    </div>
</template>

<script>
import ImportSubscribe from './components/import-subscribe';
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: "",
    status: ""
}
export default {
	props: {
		id: {
			type: [Number, String],
			default: null,
		}
	},
	components:{ImportSubscribe},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",				
                status: parseInt(this.$route.query.status) || ""
            },
            listLoading: true,
			dateType:1,
			date:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
			downLoading:false,
			userIds:[],
			publicityTime:''
        }
    },
    mounted() {
       this.getDataList(); 
    },	
    methods: {
        //获取列表
        async getDataList() {			
            this.listLoading = true;
			
            this.$request({
                url: "/subscribe/user/list",
                method: "POST",
                data: {
                    ...this.params,
					id: this.id, 
					startTime:this.date && this.date[0] || '',
					endTime:this.date && this.date[1] || ''
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result.list;
					this.dataList = result.list.result || [];
                    this.publicityTime = result.publicityTime

				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
			this.date = [];			
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
		//全选、反选
		handleSelectionChange(val) {
			this.userIds = val.map( v => v.userId );
		},
       //设置中签或取消中签  status  type为1为批量处理 type为2是单个处理
       setStatus(id,status,type){	
			if( type == 1 && this.userIds < 1  ){
				return this.$message.warning('请选择需要设置的用户');
			}else{       		
				const _msg = status == 1 ? '注意：设置为中签用户，中签公示时间后用户查询结果为“已中签”':'注意：设置为未中签用户，中签公示时间后用户查询结果为“未中签”'
				const _title = status == 1 ? '确定要将用户中签状态设置为中签吗？' : '确定要将用户中签状态设置为未中签吗？'
				var _arryids = [];
				if( type == 1 ){
					_arryids = this.userIds
				}else{
					_arryids.push(id)
				}
				console.log(_arryids)
				
				this.$confirm(_msg, _title, {
					type: 'warning',
					center: true,
					closeOnClickModal: false
				}).then(() => {
					this.listLoading = true;
					this.$request({
						url:'/subscribe/user/setStatus',
						method: 'POST',
						data: {
							id:this.id,
							userIds:_arryids,
							status:status
						},
					}).then(res => {
						const { state, msg } = res.data;
						if( state == 1 ){
							this.getDataList();
						}else{
							this.$message.error(msg || '请求失败');
						}
					}).catch(() => {
						this.$message.error('请求错误');
					}).finally(() => {
						this.listLoading = false;
					});
				}).catch(() => {})
			}
           
       },
       //导出白名单
       download(){
       	var now = this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd HH:mm:ss' );			
		let filePath;
		this.downLoading = true;
       	this.$request({
       		url: '/subscribe/user/downloadList',
       		method: 'POST',
       		data: {
       			...this.params,
       			id: this.id,
				startTime:this.date && this.date[0] || '',
				endTime:this.date && this.date[1] || ''
       		 },
       	}).then(res => {
       		const { state, msg, result } = res.data;
       		if( state == 1 && result ){
       			filePath = result.url;					
       			downloadFileTmp(filePath,`${now}_${this.$route.query.name}_白名单.`+this.$utils.getFileType(filePath));
       			this.downLoading = false;
       		}else{
       			this.downLoading = false;
       			return this.$message.error(msg || '下载失败');
       		}
       	}).catch(() => {
       		this.$message.error('请求错误');
       	}).finally(() => {
       		this.listLoading = false;
       	});
       			
       },
      
    }
}
</script>

<style lang="scss" scoped>

</style>